import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './cons-cloture-motif-type.reducer';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ConsClotureMotifTypeDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const consClotureMotifTypeEntity = useAppSelector(state => state.consClotureMotifType.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="consClotureMotifTypeDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.consClotureMotifType.detail.title">ConsClotureMotifType</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{consClotureMotifTypeEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.consClotureMotifType.code">Code</Translate>
            </span>
          </dt>
          <dd>{consClotureMotifTypeEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.consClotureMotifType.name">Name</Translate>
            </span>
          </dt>
          <dd>{consClotureMotifTypeEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.consClotureMotifType.nameAr">Name Ar</Translate>
            </span>
          </dt>
          <dd>{consClotureMotifTypeEntity.nameAr}</dd>

          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.consClotureMotifType.nameEn">Name En</Translate>
            </span>
          </dt>
          <dd>{consClotureMotifTypeEntity.nameEn}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.consClotureMotifType.status">Status</Translate>
            </span>
          </dt>
          <dd>{consClotureMotifTypeEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/cons-cloture-motif-type" replace color="info">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/cons-cloture-motif-type/${consClotureMotifTypeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ConsClotureMotifTypeDetail;
